import AnalyticsUtil from "ee/utils/AnalyticsUtil";
import type { AI_AGENT_EVENTS } from "ee/utils/analyticsUtilTypes";
import { appsmithTelemetry } from "instrumentation";

export function getLoggers({
  threadId,
  widgetId,
}: {
  widgetId: string;
  threadId: string;
}) {
  const logEvent = (event: AI_AGENT_EVENTS) => {
    AnalyticsUtil.logEvent(event, {
      threadId,
    });
  };

  const logError = (errorMessage: string) => {
    appsmithTelemetry.captureException(errorMessage, {
      errorName: "ASSISTANT_CHAT_ERROR",
      extra: {
        widgetId,
        threadId,
      },
    });
    AnalyticsUtil.logEvent("ASSISTANT_CHAT_ERROR", { error: errorMessage });
  };

  return {
    logEvent,
    logError,
  };
}
